import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api/sales`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach JWT from localStorage to every request automatically.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("riskai_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401, clear stored session — the AuthProvider will pick this up on the
// next mount / route check and redirect to /login.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("riskai_token");
      localStorage.removeItem("riskai_user");
      if (window.location.pathname !== "/sales/login") {
        window.location.assign("/sales/login");
      }
    }
    return Promise.reject(err);
  }
);

export const STAGES = [
  { id: "lead", number: 1, label: "Lead / Eerste Contact", short: "Lead" },
  { id: "demo", number: 2, label: "Demo Gegeven", short: "Demo" },
  { id: "voorstel", number: 3, label: "Voorstel / Offerte", short: "Voorstel" },
  { id: "toetsing", number: 4, label: "Formele Toetsing", short: "Toetsing", sub: "Inkoop & Juridisch" },
  { id: "gewonnen", number: 5, label: "Deal Gewonnen / Verloren", short: "Closure" },
];

export const formatEuro = (value) => {
  if (value == null) return "€0";
  if (value >= 1_000_000) return `€${(value / 1_000_000).toFixed(2)}M`;
  if (value >= 1_000) return `€${(value / 1_000).toFixed(0)}k`;
  return `€${Math.round(value)}`;
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("nl-NL", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return "—";
  }
};
